import React from "react";
import Súpuplan from "../../components/súpuplan";
import { SalotMenu } from "../../components/salot_menu";
import heroUrl from '../../resources/Frontpage2.jpg';
import cakeImg1 from '../../resources/pontunarkokur/marsipan10.JPG';
import cakeImg2 from '../../resources/pontunarkokur/kranskakaka2.jpeg';
import cakeImg3 from '../../resources/pontunarkokur/heiddukaka3.jpg';
import cakeImg4 from '../../resources/pontunarkokur/bjossi8.jpg';
import './styles.css';

const CATEGORIES = [
  { label: "Brauð", sub: "Ferskt bakað alla morgna", href: "/braud" },
  { label: "Bakkelsi", sub: "Kleinur, kringlur og kökur", href: "/bakkelsi" },
  { label: "Kökur til pöntunar", sub: "Afmæli, brúðkaup og fleira", href: "/pantanir" },
  { label: "Smurða", sub: "Samlokur og brauðsalöt", href: "/smurt" },
];

const Home = () => {
  return (
    <div className="flex flex-col">

      {/* ── Hero ── */}
      <div
        className="relative w-full h-[65vh] bg-cover bg-center"
        style={{ backgroundImage: `url(${heroUrl})` }}
      >
        <div className="absolute inset-0 bg-black/45" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
          <h1 className="text-4xl md:text-5xl text-white font-serif tracking-widest mb-3">KALLABAKARÍ</h1>
          <div className="w-16 h-0.5 bg-[#C29979] mb-5"></div>
          <p className="text-base md:text-lg text-white/75 font-serif max-w-lg leading-relaxed mb-8">
            Handverksbakarí á Akranesi — gert frá grunni, alla daga
          </p>
          <div className="flex gap-3 flex-wrap justify-center">
            <a href="/pantanir" className="h-11 px-7 inline-flex items-center rounded-xl bg-[#C29979] text-white font-serif uppercase text-sm hover:bg-[#b08060] transition-colors">
              Panta köku
            </a>
            <a href="/smarettir" className="h-11 px-7 inline-flex items-center rounded-xl border border-white/60 text-white font-serif uppercase text-sm hover:bg-white/10 transition-colors">
              Smáréttir
            </a>
          </div>
        </div>
      </div>

      {/* ── Category menu ── */}
      <div className="bg-[#1c1917]">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#2e2a28]">
          {CATEGORIES.map(({ label, sub, href }, i) => (
            <a
              key={i}
              href={href}
              className="group px-8 py-10 flex flex-col gap-3 hover:bg-[#252220] transition-colors border-b lg:border-b-0 border-[#2e2a28]"
            >
              <div className="w-8 h-0.5 bg-[#C29979] group-hover:w-14 transition-all duration-300" />
              <div className="font-serif font-semibold text-stone-100 text-base group-hover:text-[#C29979] transition-colors leading-snug">{label}</div>
              <div className="font-serif text-stone-500 text-xs leading-relaxed">{sub}</div>
              <div className="mt-1 text-stone-600 group-hover:text-[#C29979] group-hover:translate-x-1 transition-all text-sm">→</div>
            </a>
          ))}
        </div>
      </div>

      {/* ── Soup plan ── */}
      <Súpuplan />

      {/* ── CTA split with photo grid ── */}
      <div className="bg-[#F5E4CA] border-t border-amber-200 overflow-hidden">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-stretch">

          {/* Text */}
          <div className="flex-1 px-8 py-14 md:px-12 flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl font-serif text-stone-900 mb-3">Veitingar fyrir öll tilefni</h2>
            <div className="w-12 h-0.5 bg-[#C29979] mb-5"></div>
            <p className="text-stone-500 font-serif text-sm leading-relaxed mb-8">
              Afmæli · Brúðkaup · Erfidrykkjur<br />
              Fermingarveislur · Nafnaveislur · Útskriftarveislur
            </p>
            <a
              href="/pantanir"
              className="self-start h-11 px-7 inline-flex items-center rounded-xl bg-[#C29979] text-white font-serif uppercase text-sm hover:bg-[#b08060] transition-colors"
            >
              Panta hér
            </a>
          </div>

          {/* 2×2 photo grid */}
          <div className="w-full md:w-80 lg:w-96 flex-shrink-0 p-4 md:py-8 md:pr-8 md:pl-0">
            <div className="grid grid-cols-2 gap-3 h-full">
              {[cakeImg1, cakeImg2, cakeImg3, cakeImg4].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="Kaka"
                  className="w-full aspect-square object-cover rounded-xl border border-amber-100 shadow-sm"
                />
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── Salat menu ── */}
      <SalotMenu />

    </div>
  );
};

export default Home;
